import { endpoints } from '../endpoints';
import { parseResponse } from '../parseResponse';
import { getHeader } from './generalApi';

export async function getSettingsByIdentification(identification) {
  return fetch(`${endpoints.settings}/${identification}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getSelectedSettings(identifications) {
  const ids = identifications.join('&identifications=');
  return fetch(`${endpoints.settings}/identifications?identifications=${ids}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function saveSettings(settings) {
  return fetch(`${endpoints.settings}`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify(settings)
  }).then(parseResponse);
}

export async function testServerUrl(serverInfo) {
  return fetch(`${endpoints.mapserver}/server`, {
    ...(await getHeader('POST')),
    body: JSON.stringify(serverInfo)
  }).then(parseResponse);
}
